import { useCallback } from 'react';
import * as Yup from 'yup';
import { validarDocumento } from 'utils/validar-cpfcnpj';

const mensagemDocumentoInvalido = (type?: 'CPF' | 'CNPJ') => {
    if (type === 'CNPJ') {
        return 'O CNPJ está inválido.';
    }
    if (type === 'CPF') {
        return 'O CPF está inválido.';
    }
    return 'Documento inválido';
};

export const useValidationYupDocumento = (nullable: boolean) => {
    const documentoYup = useCallback((type?: 'CPF' | 'CNPJ') => {
        const validarCampo = (value?: string) => {
            if (!value || value.length === 0) {
                return true;
            }
            return validarDocumento(value, type);
        };

        if (nullable) {
            return Yup.string().test(
                'documento',
                mensagemDocumentoInvalido(type),
                (value) => validarCampo(value),
            );
        }

        return Yup.string()
            .required(`O ${type !== undefined ? type : 'documento'} é obrigatório.`)
            .test(
                'documento',
                mensagemDocumentoInvalido(type),
                (value) => validarCampo(value),
            );
    }, [nullable]);

    return {
        documentoYup,
    };
};
